import axios from '../../services/axios';

function actionCompleted(action) {
  return axios({
    method: 'POST',
    url: `/loyalty_program/${action}.json`,
  });
}

function redeem(actionId) {
  return axios({
    method: 'POST',
    url: `/loyalty_program/redeem/${actionId}.json`,
  });
}

function reactivateLoyaltyProgram() {
  return axios({
    method: 'POST',
    url: '/loyalty_program/reactivate.json',
  });
}

const api = {
  actionCompleted,
  redeem,
  reactivateLoyaltyProgram,
};

export default api;
